/* @flow weak */
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import Input from 'components/Input.jsx';
import Link from 'components/Link.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import React from 'react';

import './styles/DecoratedInput.scss';

export const LoadingInput = ({ className, ...rest }) =>
  <div className={cx('DecoratedInput DecoratedInput--loading', className)}>
    <LoadingIndicator size="small" className="DecoratedInput-loader" />
    <Input {...rest} disabled />
  </div>;

export const ClosableInput = ({ className, onClose, eventScreenName, eventElementName, ...rest }) =>
  <div className={cx('DecoratedInput DecoratedInput--closable', className)}>
    <Input {...rest} disabled />
    <Link
      color="thunder"
      eventScreenName={eventScreenName}
      eventElementName={eventElementName}
      onClick={onClose}>
      <Glyph
        name="close-circle"
        size="large"
        className="DecoratedInput-glyph"
        solo
      />
    </Link>
  </div>;

ClosableInput.propTypes = {
  onClose: React.PropTypes.func,
  eventElementName: React.PropTypes.string,
  eventScreenName: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/DecoratedInput.jsx